import { Component, OnInit, Input, TemplateRef } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import * as moment from "moment";
import {
  CandidatesService,
  SessionService,
  JobOffersService,
} from "../../services";
import { Observable } from "rxjs";
import { WebinarsService } from "app/services/webinars.service";
import {
  CandidateEntityModel,
  CandidateModel,
  JobOfferModel,
  ListEntityModel,
  UserJobsEntityModel,
} from "app/interfaces";
import { environment } from "environments/environment";

@Component({
  selector: "app-export-btn",
  templateUrl: "./app-export-btn.component.html",
  styleUrls: ["./app-export-btn.component.scss"],
  providers: [
    SessionService,
    // CandidatesService,
    // JobOffersService
  ],
})
export class AppExportBtnComponent implements OnInit {
  public separator = ";";
  public exporting = false;
  public fileName = "";
  @Input() disabled = false;
  @Input() candidates = [];
  @Input() referenceId = "";
  @Input() type: string; // 0: global candidates, 1: single job, 2: single job clicks
  @Input() currentTab: string;
  @Input() external = false;
  @Input() filter!: any;
  @Input() version!: string;
  modalRef: BsModalRef;
  template: TemplateRef<any>;

  private status: any = {
    student: "In progress",
    graduated: "Finished",
  };

  constructor(
    private modalService: BsModalService,
    private candidatesService: CandidatesService,
    private sessionService: SessionService,
    private jobOfferService: JobOffersService,
    private webinarsService: WebinarsService
  ) { }

  ngOnInit() {
    // console.log(this.candidates);
  }

  private convertCandidatesToCsv(candidates): string {
    // console.log('candidates', candidates);
    // console.log('type', this.type);
    // console.log('referenceId', this.referenceId);
    let csv =
      "Candidate" +
      this.separator +
      "Birthdate" +
      this.separator +
      "Age" +
      this.separator +
      "City" +
      this.separator +
      "University" +
      this.separator +
      "Faculty" +
      this.separator +
      "Course" +
      this.separator +
      "Status" +
      this.separator +
      "Started at" +
      this.separator +
      "Finished at" +
      this.separator +
      "Expected finished at" +
      this.separator +
      "Qualification" +
      this.separator +
      "Vote" +
      this.separator +
      "Average" +
      this.separator +
      "Email" +
      this.separator +
      "Phone" +
      this.separator +
      "Address" +
      this.separator +
      "PDF Link" +
      this.separator +
      "Job Offer Id" +
      this.separator +
      "Job Offer Position" +
      this.separator +
      "Application Date" +
      this.separator +
      "Score" +
      this.separator +
      "Comment" +
      this.separator +
      "Process Status" +
      this.separator +
      "Tags";

    csv += "\n";

    switch (this.type) {
      case "candidates":
        this.fileName = "candidates";
        candidates.forEach((candidate: CandidateModel) => {
          candidate.User.UserJobs.forEach((job: UserJobsEntityModel) => {
            csv += candidate.User.name + " " + candidate.User.surname;
            csv += this.separator;

            csv += candidate.User.birthdate
              ? moment(candidate.User.birthdate).format("DD/MM/YYYY")
              : "";
            csv += this.separator;

            csv += candidate.User.birthdate
              ? moment().diff(candidate.User.birthdate, "years")
              : "";
            csv += this.separator;

            const edu =
              candidate.User.AcademicQualifications.filter(
                (aq) => aq.is_current
              )[0] || null;

            csv += edu && edu.City ? edu.City.name : "";
            csv += this.separator;

            csv += edu && edu.university_name ? edu.university_name : "";
            csv += this.separator;

            csv +=
              edu && edu.StudyTag.MacroStudyTag
                ? edu.StudyTag.MacroStudyTag.name_en.replace(
                  /[^a-zA-Z0-9]/g,
                  " "
                )
                : "";
            csv += this.separator;

            csv +=
              edu && edu.course_name
                ? edu.course_name.replace(/[^a-zA-Z0-9]/g, " ")
                : "";
            csv += this.separator;

            csv += edu && edu.status ? edu.status : "";
            csv += this.separator;

            csv +=
              edu && edu.started_at
                ? moment(edu.started_at).format("DD/MM/YYYY")
                : "";
            csv += this.separator;

            csv +=
              edu && edu.finished_at
                ? moment(edu.finished_at).format("DD/MM/YYYY")
                : "";
            csv += this.separator;

            csv +=
              edu && edu.expected_finished_at
                ? moment(edu.expected_finished_at).format("DD/MM/YYYY")
                : "";
            csv += this.separator;

            csv +=
              edu && edu.qualification_name
                ? edu.qualification_name.replace(/[^a-zA-Z0-9]/g, " ")
                : "";
            csv += this.separator;

            csv += edu && edu.vote ? edu.vote : "";
            csv += this.separator;

            csv += edu && edu.avg ? edu.avg : "";
            csv += this.separator;

            csv += candidate.User.contact_email || "";
            csv += this.separator;

            csv += candidate.User.contact_phone || "";
            csv += this.separator;

            csv += candidate.User.geolocation
              ? candidate.User.geolocation.formattedName.replace(
                /[^a-zA-Z0-9]/g,
                " "
              )
              : "";
            csv += this.separator;

            csv += `${environment.baseUrl}/pdf-download/${candidate.User.id}/${candidate.User.name}-${candidate.User.surname}`;
            csv += this.separator;

            // job data
            csv += job.JobOffer.id;
            csv += this.separator;

            csv += job.JobOffer.position.replace(/[^a-zA-Z0-9]/g, " ");
            csv += this.separator;

            csv += job.applied_at;
            csv += this.separator;

            csv += Math.round((job as any).user_score) * 100 + "%";
            csv += this.separator;

            csv += job.comment
              ? job.comment.replace(/[^a-zA-Z0-9]/g, " ")
              : " ";
            csv += this.separator;

            csv += job.process_status ? job.process_status : " ";
            csv += this.separator;

            csv += job.Tags
              ? job.Tags.map((a) => a.name)
                .toString()
                .replace(/[^a-zA-Z0-9]/g, " ")
                .trim()
              : "";

            csv += "\n";
          });
        });
        break;
      case "checkIns":
        this.fileName = "check_ins_for_event_" + this.referenceId;
        csv =
          "Candidate" +
          this.separator +
          "City" +
          this.separator +
          "University" +
          this.separator +
          "Faculty" +
          this.separator +
          "Course" +
          this.separator +
          "Email" +
          this.separator +
          "Phone" +
          this.separator +
          "User answer" +
          this.separator +
          "Comments" +
          "\n";
        candidates.forEach((candidate) => {
          csv +=
            (candidate["users"]["name"]
              ? candidate["users"]["name"].trim()
              : "") +
            " " +
            (candidate["users"]["surname"]
              ? candidate["users"]["surname"].trim()
              : "");
          csv +=
            this.separator +
            (candidate["city_name"] ? candidate["city_name"] : "");
          csv +=
            this.separator +
            (candidate["university_name"] ? candidate["university_name"] : "");
          csv +=
            this.separator +
            (candidate["faculty_name"]
              ? candidate["faculty_name"].replace(/,/g, "").trim()
              : "");
          csv +=
            this.separator +
            (candidate["course_name"]
              ? candidate["course_name"].replace(/,/g, "").trim()
              : "");
          csv +=
            this.separator +
            (candidate["users"]["contact_email"]
              ? candidate["users"]["contact_email"]
              : candidate["users"]["email"]
                ? candidate["users"]["email"]
                : "");
          csv +=
            this.separator +
            (candidate["users"]["contact_phone"]
              ? candidate["users"]["contact_phone"].trim()
              : "");
          csv +=
            this.separator +
            (candidate["answer"]
              ? '"' + candidate["answer"].replace(/\r?\n|\r/g, "") + '"'
              : "");
          csv +=
            this.separator +
            (candidate["comments"]
              ? '"' + candidate["comments"].replace(/\r?\n|\r/g, "") + '"'
              : "");
          csv += "\n";
        });
        break;
      case "job_candidates":
        this.fileName = "candidates_for_job_offer_" + this.referenceId;
        csv = "Candidate" + this.separator;
        if (!this.external) {
          csv += "Birthdate" + this.separator + "Age" + this.separator;
        }
        csv +=
          "University" +
          this.separator +
          "Faculty" +
          this.separator +
          "Degree Level";
        //  +
        // this.separator +
        // "Status"
        if (!this.external) {
          csv +=
            this.separator +
            "Email" +
            this.separator +
            "Phone" +
            this.separator +
            "Address";
        }

        csv +=
          this.separator + "Job Offer Id" + this.separator + "Application Date";
        if (this.version === "v7") {
          csv += this.separator + "Score";
        }
        if (!this.external) {
          csv +=
            this.separator +
            "Comment" +
            this.separator +
            "Process Status" +
            this.separator +
            "Tags" +
            this.separator +
            "PDF Link";
        }
        csv += "\n";
        candidates.forEach((candidate: CandidateEntityModel) => {
          // console.log('candidate', candidate);
          csv +=
            (candidate.User.name ? candidate.User.name.trim() : "") +
            " " +
            (candidate.User.surname ? candidate.User.surname.trim() : "");
          csv += this.separator;
          if (!this.external) {
            csv += candidate.User.birth_date
              ? moment(candidate.User.birth_date).format("DD/MM/YYYY")
              : "";
            csv += this.separator;

            csv += candidate.User.birth_date
              ? moment().diff(candidate.User.birth_date, "years")
              : "";
            csv += this.separator;
          }

          // const edu = candidate.User.AcademicQualifications.filter(aq => aq.is_current)[0] || null;
          const edu = candidate.User.Education;
          csv += edu && edu.Institute ? edu.Institute.name : "";
          csv +=
            this.separator +
            (edu && edu.StudyTag
              ? edu.StudyTag.name_en.replace(/[,:;."\n]/g, "").trim()
              : "");
          csv +=
            this.separator +
            (edu && edu.study_tags_level ? edu.study_tags_level : "");
          // csv +=
          //   this.separator +
          //   (candidate.User.status ? candidate.User.status.value : "");
          if (!this.external) {
            csv +=
              this.separator +
              (candidate.User.contact_email
                ? candidate.User.contact_email
                : "");
            csv +=
              this.separator +
              (candidate.User.phone ? candidate.User.phone : "");
            csv +=
              this.separator +
              (candidate.User.contact_address
                ? candidate.User.contact_address
                : "");
          }

          csv += this.separator + this.referenceId;
          csv +=
            this.separator +
            (candidate.created_at
              ? moment(candidate.created_at).format("DD/MM/YYYY HH:mm")
              : "");
          if (this.version === "v7") {
            csv += this.separator;
            csv += Math.round((candidate as any).user_score * 100) + "%";
          }
          // csv += this.separator + 'FIX-ME';
          if (!this.external) {
            csv +=
              this.separator +
              (candidate.comment
                ? candidate.comment.replace(/[,:;."\n]/g, "").trim()
                : "");
            // csv += this.separator + (application.status ? application.status : '');
            csv +=
              this.separator +
              (candidate.process_status
                ? candidate.process_status === "new" || candidate.process_status === "pending"
                  ? "to check"
                  : candidate.process_status
                : "");
            csv +=
              this.separator +
              (candidate.tags
                ? candidate.tags
                  .map((a) => a.value)
                  .toString()
                  .replace(/[,:;."\n]/g, " ")
                  .trim()
                : "");
            csv +=
              this.separator +
              `${environment.baseUrl}/pdf-download/${candidate.id}/${candidate.User.name}-${candidate.User.surname}`;
          }
          csv += "\n";
        });
        break;
      case "webinar_participants":
        const states: { [key: string]: string } = {
          offline: "Viewer",
          participated: "Participated",
          registered: "Not Participated",
        };
        this.fileName = "webinar_paticipants_" + this.referenceId;
        csv =
          "Candidate" +
          this.separator +
          // 'City' +
          // this.separator +
          "University" +
          this.separator +
          "Study Area" + // name_en
          this.separator +
          // 'Course' +
          // this.separator +
          "Email" +
          this.separator +
          // 'Phone' +
          // this.separator +
          // 'Job Offer Id' +
          // this.separator +
          "Status" +
          "\n";
        candidates.forEach((candidate: ListEntityModel) => {
          csv +=
            (candidate.user.name ? candidate.user.name.trim() : "") +
            " " +
            (candidate.user.surname ? candidate.user.surname.trim() : "");
          // csv +=
          //   this.separator +
          //   (candidate.user.contact_address
          //     ? candidate.user.contact_address
          //     : '');
          csv +=
            this.separator +
            (candidate.user.Education.Institute
              ? candidate.user.Education.Institute.name
              : "");
          csv += this.separator + candidate.user.Education.StudyTag.name_en;
          // (candidate['User']['AcademicQualifications'] && candidate['User']['AcademicQualifications'] && ['0']['StudyTag']['MacroStudyTag']['name_en']
          //   ? candidate['User']['AcademicQualifications']['0']['StudyTag']['MacroStudyTag']['name_en']
          //     .replace(/,/g, '')
          //     .trim()
          //   : '');
          // csv +=
          //   this.separator +
          //   (candidate['User']['university_course_view']['course_name']
          //     ? candidate['User']['university_course_view']['course_name']
          //       .replace(/,/g, '')
          //       .trim()
          //     : '');
          csv +=
            this.separator +
            (candidate["user"]["contact_email"]
              ? candidate["user"]["contact_email"]
              : candidate["user"]["email"]
                ? candidate["user"]["email"]
                : "");
          // csv +=
          //   this.separator +
          //   (candidate['User']['contact_phone']
          //     ? candidate['User']['contact_phone']
          //     : '');
          // csv += this.separator + this.referenceId;
          csv +=
            this.separator +
            (states[candidate["state"]] ? states[candidate["state"]] : "") +
            "\n";
        });
        break;
    }
    return csv;
  }

  public printCSV() {
    this.exporting = true;
    if (this.candidates && this.candidates.length > 0) {
      let csv;
      // if (this.type === 'candidates') {
      //   let stored = this.sessionService.get('candidates_filters');
      //   if (stored) {
      //     stored = JSON.parse(stored);
      //     this.candidatesService
      //       .getCandidatesFromFilters(stored)
      //       .subscribe(allCandidates => {
      //         // console.log('allCandidates', allCandidates);
      //         csv = this.convertCandidatesToCsv(allCandidates);
      //         return this.finalizeCSV(csv);
      //       });
      //   }
      // } else {
      csv = this.convertCandidatesToCsv(this.candidates);
      // }
      if (csv == null) {
        return;
      }
      return this.finalizeCSV(csv);
    } else {
      // FIX-ME
      // no candidates
      switch (this.type) {
        case "webinar_participants": {
          this.getWebinarParticipants().then((data) => {
            this.candidates = data;
            this.printCSV();
          });
          break;
        }
        case "job_candidates": {
          this.getJobCandidates().then((data) => {
            this.candidates = data;
            this.printCSV();
          });
          break;
        }
        case "candidates": {
          this.getCandidates().then((data) => {
            this.candidates = data;
            this.printCSV();
          });
          return;
          let stored = this.sessionService.get("candidates_filters");
          if (stored) {
            stored = JSON.parse(stored);
            this.candidatesService
              .getCandidatesFromFilters(stored)
              .subscribe((allCandidates) => {
                // console.log('allCandidates', allCandidates);
                const csv = this.convertCandidatesToCsv(allCandidates);
                return this.finalizeCSV(csv);
              });
          }
          break;
        }
        default:
          break;
      }
    }
  }

  private getCurrentAcademicQualificationStudyTag(acc: any[]): string {
    let studyTag = "";
    const current = acc.filter((a) => a.is_current)[0];

    if (current) {
      studyTag = current.StudyTag.MacroStudyTag.name_en;
    }

    return studyTag;
  }

  private getCandidates(): Promise<any> {
    let page = 0;
    const limit = 500;
    let output = [];
    const stored = this.sessionService.get("candidates_filters")
      ? JSON.parse(this.sessionService.get("candidates_filters"))
      : {};

    // if (stored['tags_ids'] && stored['tags_ids'].length > 0) {
    //   const ti = [];
    //   stored['tags_ids'].forEach(t => ti.push(t.id));
    //   stored['tags_ids'] = ti;
    // }

    // if (stored['job_offers_id'] && typeof stored['job_offers_id'] === 'object') {
    //   stored['job_offers_id'] = stored['job_offers_id']['value'];
    // }

    // if (stored['universities_ids'] && stored['universities_ids'].length > 0) {
    //   const ti = [];
    //   stored['universities_ids'].forEach(t => ti.push(t.id));
    //   stored['universities_ids'] = ti;
    // }

    let sanitizedFilters = JSON.parse(JSON.stringify(stored));
    if (sanitizedFilters["job_offers_id"]) {
      sanitizedFilters["job_offers_id"] =
        sanitizedFilters["job_offers_id"].value;
    }
    if (sanitizedFilters["languages_id"]) {
      sanitizedFilters["languages_id"] = Number(
        sanitizedFilters["languages_id"].value
      );
    }
    if (sanitizedFilters["language_level"]) {
      sanitizedFilters["language_level"] = Number(
        sanitizedFilters["language_level"].value
      );
    }
    if (sanitizedFilters["cities_ids"] && sanitizedFilters["cities_ids"][0]) {
      sanitizedFilters["cities_ids"][0] = sanitizedFilters["cities_ids"][0].id;
    }
    if (
      sanitizedFilters["universities_ids"] &&
      sanitizedFilters["universities_ids"][0]
    ) {
      sanitizedFilters["universities_ids"][0] =
        sanitizedFilters["universities_ids"][0].id;
    }
    if (
      sanitizedFilters["faculty_tags"] &&
      sanitizedFilters["faculty_tags"][0]
    ) {
      sanitizedFilters["faculty_tags"][0] =
        sanitizedFilters["faculty_tags"][0].id;
    }
    if (sanitizedFilters["tags_ids"] && sanitizedFilters["tags_ids"][0]) {
      sanitizedFilters["tags_ids"][0] = sanitizedFilters["tags_ids"][0].id;
    } else {
      delete sanitizedFilters["tags_ids"];
    }
    if (sanitizedFilters["skills_ids"] && sanitizedFilters["skills_ids"][0]) {
      sanitizedFilters["skills_ids"][0] = sanitizedFilters["skills_ids"][0].id;
    }

    return new Promise((resolve, reject) => {
      const call = () => {
        // this.jobOfferService.getCurricula(Number(this.referenceId), page, limit)
        this.candidatesService
          .getAll(sanitizedFilters, page, limit)
          .toPromise()
          .then((data) => {
            output = output.concat(data["rows"]);
            // if (data['count'] < limit) {
            if (data["rows"].length > 0 && output.length < data["total"]) {
              page++;
              call();
            } else {
              resolve(output);
            }
          });
      };

      call();
    });
  }

  private getJobCandidates(): Promise<any> {
    let page = 0;
    const limit = 20;
    let output = [];

    return new Promise((resolve, reject) => {
      const call = () => {
        this.jobOfferService
          .getCurriculaJobOfferByVersion(
            Number(this.referenceId),
            this.version,
            page,
            limit,
            this.filter
          )
          .toPromise()
          .then((data) => {
            // console.log('data',data);
            output = output.concat(data.response.list);
            // if (data['count'] < limit) {
            if (
              data.response.list.length > 0 &&
              output.length < data.response.total
            ) {
              page++;
              call();
            } else {
              // console.log('output', output);
              resolve(output);
            }
          });
      };

      call();
    });
  }

  private getWebinarParticipants(): Promise<any> {
    let page = 0;
    const limit = 500;
    let output = [];
    return new Promise((resolve, reject) => {
      const call = () => {
        this.webinarsService
          .getWebinarsParticipants(
            Number(this.referenceId),
            page,
            limit,
            this.filter
          )
          .toPromise()
          .then((data) => {
            output = output.concat(data.list);
            // if (data['count'] < limit) {
            if (data.list.length > 0 && output.length < data.total) {
              page++;
              call();
            } else {
              resolve(output);
            }
          });
      };

      call();
    });
  }

  private finalizeCSV(csv) {
    let link;
    link = document.createElement("a");
    const formBlob = new Blob([csv], { type: "text/csv" });
    link.href = window.URL.createObjectURL(formBlob);
    link.setAttribute(
      "download",
      moment().format("DD-MM-YYYY") + "_" + this.fileName + ".csv"
    );
    if (this.type === "candidates") {
      link.setAttribute(
        "download",
        moment().format("DD-MM-YYYY") + "_" + "candidates.csv"
      );
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    this.exporting = false;
    this.modalRef.hide();
  }

  openModal(template: TemplateRef<any>) {
    this.template = template;
    this.modalRef = this.modalService.show(template);
  }

  changeSeparator(event) {
    this.separator = event.target.value;
  }
}
